// components/CustomerType.js
import React, { useState, useEffect } from 'react';
import { TextField, ListItem, ListItemText } from '@mui/material';
import debounce from 'lodash.debounce';
import CustomerType from './CustomerType';
import PersonalData from './PersonalData';
import BusinessData from './BusinessData';
import ModalAddCliente from '../../ModalAddCliente';
import { RowContainer, BaseLabel, AutoComplete, ImportButton, ImportButtonBlue } from '../../../styles/styleUtils';

import { getClientesPagina } from '../../api';

function CustomerData({ formData, onOpenCliente, onOpen, onAutoCompleteChange, onInputChange, disabled }) {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [openAddCliente, setOpenAddCliente] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async (value) => {
    const result = await getClientesPagina({ nome: value, page: 1, limit: 100 });
    setOptions(result.clientes);
  };

  // Sempre que digitar algo novo
  const handleInputChange = (event, value, reason) => {
    setInputValue(value);
    if (reason === 'input') {
      debouncedFetch(value);
    }
  };

  // Debounce evita chamadas excessivas
  const debouncedFetch = debounce((value) => {
    if (value.length >= 2) {
      // mínimo de caracteres
      fetchData(value);
    }
  }, 500);

  const handleAlterarCadastro = () => {
    setOpenAddCliente(true);
  };

  const handleClose = () => {
    setOpenAddCliente(false);
  };

  const onConfirmHandler = async (cliente) => {
    await fetchData()
    onAutoCompleteChange('idCliente', 'cliente', cliente);
    handleClose();
  };

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="nomeCliente">Nome do Cliente</BaseLabel>
        <AutoComplete
          disablePortal
          id="cliente"
          name="cliente"
          value={formData.cliente || null}
          onChange={(_, value) => onAutoCompleteChange('idCliente', 'cliente', value)}
          inputValue={inputValue}
          onInputChange={handleInputChange}
          options={options}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          renderOption={(props, option) => (
            <ListItem key={option._id} {...props}>
              <ListItemText primary={option.nome} secondary={option.cpf} />
            </ListItem>
          )}
          getOptionLabel={(option) => `${option.nome} - ${option.cpf} (${option._id})`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
          disabled={disabled}
        />
        {!formData.cliente && <ImportButton onClick={onOpen}>Importar Dados</ImportButton>}
        {formData.cliente && <ImportButtonBlue onClick={handleAlterarCadastro}>Alterar Cadastro</ImportButtonBlue>}
      </RowContainer>
      {formData.cliente && (
        <>
          <CustomerType formData={formData} />
        </>
      )}

      {formData.cliente?.tipoCliente === 'F' && <PersonalData formData={formData} onInputChange={onInputChange} />}
      {formData.cliente?.tipoCliente === 'J' && <BusinessData formData={formData} onInputChange={onInputChange} />}

      {openAddCliente && (
        <ModalAddCliente
          open={openAddCliente}
          produto={formData.cliente}
          onClose={handleClose}
          onConfirm={onConfirmHandler}
        />
      )}
    </div>
  );
}

export default CustomerData;
